module.exports = __webpack_public_path__ + "static/media/img_02.935a977a.png";